<template>
  <common-template>
      <div class="list">
        <h1 class="title d-flex border-bottom inner">{{ $t(pageTitle) }}</h1>
        <div class="inner">
          <h3>{{ $t(pageTitle) }}</h3>
          <div class="projectbox">
            <div class="hiddenBox">
              <h2>{{ $t('非表示項目') }}</h2>
              <div class="connection">
                <draggable class="list-group" :list="hiddens" group="forms" @start="drugStart" @end="drugEnd">
                  <div
                    class="list-group-item"
                    :class="{
                      'isRequire': element.require
                    }"
                    v-for="(element) in hiddens"
                    :key="element.name"
                  >
                    {{ $t(element.name) }}
                  </div>
                </draggable>
              </div>
            </div>
            <div class="visibleBox">
              <h2>{{ $t('表示項目') }}</h2>
              <div class="connection">
                <draggable class="list-group" :list="visibles" group="forms" @start="drugStart" @end="drugEnd">
                  <div
                    class="list-group-item"
                    :class="{
                      'isRequire': element.require
                    }"
                    v-for="(element) in visibles"
                    :key="element.name"
                  >
                    {{ $t(element.name) }}
                  </div>
                </draggable>
              </div>
            </div>
            <div class="preview">
              <h2>{{ $t('表示プレビュー') }}</h2>
              <div class="previewBox">
                <div class="box" v-for="(item, index) in visibles" :key="index" :class="{'full':item.isFull}">
                  <span>{{ $t(item.name) }}</span>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="inner">
          <h3>{{ $t('材料情報カスタマイズ') }}</h3>
          <div class="projectbox">
            <div class="hiddenBox">
              <h2>{{ $t('非表示項目') }}</h2>
              <div class="connection">
                <draggable class="list-group" :list="materialHiddens" group="forms" @start="materialDrugStart" @end="materialDrugEnd">
                  <div
                    class="list-group-item"
                    :class="{
                      'isRequire': element.require
                    }"
                    v-for="(element) in materialHiddens"
                    :key="element.name"
                  >
                    {{ $t(element.name) }}
                  </div>
                </draggable>
              </div>
            </div>
            <div class="visibleBox">
              <h2>{{ $t('表示項目') }}</h2>
              <div class="connection">
                <draggable class="list-group" :list="materialVisibles" group="forms" @start="materialDrugStart" @end="materialDrugEnd">
                  <div
                    class="list-group-item"
                    :class="{
                      'isRequire': element.require
                    }"
                    v-for="(element) in materialVisibles"
                    :key="element.name"
                  >
                    {{ $t(element.name) }}
                  </div>
                </draggable>
              </div>
            </div>
            <div class="preview">
              <h2>{{ $t('表示プレビュー') }}</h2>
              <div class="previewBox">
                <div class="box" v-for="(item, index) in materialVisibles" :key="index" :class="{'full':item.isFull,'heaf':item.isHeaf}">
                  <span>{{ $t(item.name) }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="control_btns">
            <div class="btns1">
              <button class="btn btn-warning" @click="resetData">{{ $t('リセット') }}</button>
            </div>
            <div class="btns2">
              <button class="btn btn-light mr-5" @click="cancelData">{{ $t('キャンセル') }}</button>
              <button class="btn btn-success" @click="registData">{{ $t('登録') }}</button>
            </div>
          </div>
        </div>


      </div>

  </common-template>
</template>

<script>
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'
import helper from '../../mixin/helper'

export const defaultSettings = {
  hiddens: [
    { name: 'ロットNo.', require: false, isFull: false, isHeaf: false, id: 'lotNo' },
    { name: '作成者', require: false, isFull: false, isHeaf: false, id: 'createdByName' },
    { name: '品名', require: false, isFull: false, isHeaf: false, id: 'productName' },
    { name: '客先品番', require: false, isFull: false, isHeaf: false, id: 'customerProductCode' },
    { name: '図番', require: false, isFull: false, isHeaf: false, id: 'figureNo' },
    { name: '仕掛日', require: false, isFull: false, isHeaf: false, id: 'prepareDate' },
    { name: '受注先', require: false, isFull: false, isHeaf: false, id: 'partnerName' },
    { name: '手配部署', require: false, isFull: false, isHeaf: false, id: 'orderContactName' },
    { name: '送り先', require: false, isFull: false, isHeaf: false, id: 'destContactName' },
    { name: '受注単価', require: false, isFull: false, isHeaf: false, id: 'orderUnitPrice'},
    { name: '受注額', require: false, isFull: false, isHeaf: false, id: 'orderPrice'},
    { name: '工場', require: false, isFull: false, isHeaf: false, id: 'factoryName'},
    { name: '図面/画像', require: false, isFull: true, isHeaf: false, id: 'files' },
    { name: '備考', require: false, isFull: true, isHeaf: false, id: 'note'},
    { name: '自由記述項目1', require: false, isFull: false, isHeaf: false, id: 'freedom1' },
    { name: '自由記述項目2', require: false, isFull: false, isHeaf: false, id: 'freedom2' },
    { name: '自由記述項目3', require: false, isFull: false, isHeaf: false, id: 'freedom3' },
    { name: '自由記述項目4', require: false, isFull: false, isHeaf: false, id: 'freedom4' },
    { name: '自由記述項目5', require: false, isFull: false, isHeaf: false, id: 'freedom5' },
    { name: '自由記述項目6', require: false, isFull: true, isHeaf: false, id: 'freedom6' },
    { name: '自由記述項目7', require: false, isFull: true, isHeaf: false, id: 'freedom7' },
    { name: '自由記述項目8', require: false, isFull: true, isHeaf: false, id: 'freedom8' },
    { name: '自由記述項目9', require: false, isFull: true, isHeaf: false, id: 'freedom9' },
  ],
  visibles: [
    { name: '案件', require: true, isFull: true, isHeaf: false, id: 'projectStatus' },
    { name: '案件No.', require: true, isFull: false, isHeaf: false, id: 'no'},
    { name: '品番', require: true, isFull: false, isHeaf: false, id: 'productCode' },
    { name: '納期', require: true, isFull: false, isHeaf: false, id: 'deliveryDate' },
    { name: '数量', require: true, isFull: false, isHeaf: false, id: 'orderQuantity' },
    { name: '表示色', require: true, isFull: false, isHeaf: false, id: 'displayColor'},
  ],
  materialHiddens: [
    { name: '材料名/材質', require: false, isFull: false, isHeaf: true, id: 'materialName' },
    { name: '材料寸法', require: false, isFull: false, isHeaf: true, id: 'materialSize' },
    { name: '材料備考', require: false, isFull: false, isHeaf: false, id: 'materialNote'},
    { name: 'RoHS指令対応', require: false, isFull: false, isHeaf: false, id: 'materialIsRohs'},
    { name: '基準単価', require: false, isFull: false, isHeaf: false, id: 'materialUnitPrice'},
    { name: '基準手配リードタイム', require: false, isFull: false, isHeaf: false, id: 'materialLeadTime'},
    { name: '重量', require: false, isFull: false, isHeaf: false, id: 'materialShapeWeight'},
    { name: '備考', require: false, isFull: true, isHeaf: false, id: 'materialNote'},
  ],
  materialVisibles: [
    { name: '材料管理コード', require: true, isFull: false, id: 'materialCode' },
  ],
}

export default {
  mixins: {
    helper,
  },
  data() {
    return {
      hiddens: [],
      visibles: [],
      materialHiddens: [],
      materialVisibles: [],
      tempHiddens: [],
      tempVisibles: [],

      tempMaterialHiddens: [],
      tempMaterialVisibles: [],

      remark: false,
      detailImage: false,

      master: {},
      load: false,
      userId: '',
      setting: false,
      isPost: true,
      type: 'project',
      id: false,
      pageTitle: '作業指示書レイアウト設定',
    }
  },
  components: {
    draggable,
  },
  updated() {
    if (this.type === 'project') {
      this.pageTitle = '案件情報レイアウト設定'
    } else {
      this.pageTitle = '作業指示書レイアウト設定'
    }
    document.title = this.$t(this.pageTitle)
  },
  async created() {
    this.load = true

    const url = location.search
    const searchParams = new URLSearchParams(url)
    if (searchParams.get('type')) {
      this.type = searchParams.get('type')
    }

    await this.getMasterData()
    await this.loadSettingData()

    if (this.setting) {
      this.visibles = this.mixin_deepcopy(this.setting.visibles)
      this.hiddens = this.mixin_deepcopy(this.setting.hiddens)
      this.materialVisibles = this.mixin_deepcopy(this.setting.materialVisibles)
      this.materialHiddens = this.mixin_deepcopy(this.setting.materialHiddens)
      this.isPost = this.id === null
    } else {
      this.visibles = this.mixin_deepcopy(defaultSettings.visibles)
      this.hiddens = this.mixin_deepcopy(defaultSettings.hiddens)
      this.materialVisibles = this.mixin_deepcopy(defaultSettings.materialVisibles)
      this.materialHiddens = this.mixin_deepcopy(defaultSettings.materialHiddens)
      this.isPost = true
    }
  },
  methods: {

    async getMasterData() {
      try {
        this.master = []
        const res = await this.$axios.get(`${this.$appConfig.CommonApiUrl}/masters`, {
          headers: {
            'Authorization': this.authorization ? this.authorization : null,
          },
        })
        this.master = res.data
      } catch (err) {
        this.$toasted.show(this.$t('データの取得に失敗しました。'))
      }
    },

    async loadSettingData() {
      try {
        const res = await this.$axios.get(`${this.$appConfig.CommonApiUrl}/company/preferences`, {
          headers: {
            'Authorization': this.authorization ? this.authorization : null,
          },
          params: {
            companyId: this.master.company.id,
            type: this.type,
          },
        })
        if (res.data.length) {
          this.setting = res.data[0].preference
          this.id = res.data[0].id
        }

      } catch (err) {
        this.$toasted.show(this.$t('データの取得に失敗しました。'))
      }
    },

    drugEnd() {
      const requires = this.hiddens.filter(item => item.require)
      if (requires.length) {
        this.hiddens = JSON.parse(JSON.stringify(this.tempHiddens))
        this.visibles = JSON.parse(JSON.stringify(this.tempVisibles))
      }
    },
    drugStart() {
      this.tempHiddens = JSON.parse(JSON.stringify(this.hiddens))
      this.tempVisibles = JSON.parse(JSON.stringify(this.visibles))
    },

    materialDrugEnd() {
      const requires = this.materialHiddens.filter(item => item.require)
      if (requires.length) {
        this.materialHiddens = JSON.parse(JSON.stringify(this.tempMaterialHiddens))
        this.materialVisibles = JSON.parse(JSON.stringify(this.tempMaterialVisibles))
      }
    },
    materialDrugStart() {
      this.tempMaterialHiddens = JSON.parse(JSON.stringify(this.materialHiddens))
      this.tempMaterialVisibles = JSON.parse(JSON.stringify(this.materialVisibles))
    },

    async resetData() {
      // this.visibles = this.mixin_deepcopy(defaultSettings.visibles)
      // this.hiddens = this.mixin_deepcopy(defaultSettings.hiddens)
      // this.materialVisibles = this.mixin_deepcopy(defaultSettings.materialVisibles)
      // this.materialHiddens = this.mixin_deepcopy(defaultSettings.materialHiddens)

      const confirm = await this.$swal({
        text: '設定をリセットします。',
        className: 'swal-none',
        buttons: {
          cancel: {
            text: this.$t('キャンセル'),
            value: null,
            visible: true,
            className: 'btn-light',
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            value: true,
            visible: true,
            className: 'btn-light',
            closeModal: true,
          },
        },
        dangerMode: true,
      })
      if (confirm) {
        const params = {
          companyId: this.master.company.id,
          id: this.id,
        }

        try {

          await this.$axios({
            method: 'post',
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
            url: `${this.$appConfig.CommonApiUrl}/company/preference/reset`,
            data: params,
          })

          this.$toasted.success(this.$t('登録が完了しました。'))
          await this.loadSettingData()
          this.visibles = this.mixin_deepcopy(this.setting.visibles)
          this.hiddens = this.mixin_deepcopy(this.setting.hiddens)
          this.materialVisibles = this.mixin_deepcopy(this.setting.materialVisibles)
          this.materialHiddens = this.mixin_deepcopy(this.setting.materialHiddens)
        } catch (err) {
          console.log(err)
          this.$toasted.show(this.$t('データの登録に失敗しました。'))
        }
      }
    },
    async cancelData() {
      const confirm = await this.$swal({
        text: '設定を変更せずメニューに戻ります。',
        className: 'swal-none',
        buttons: {
          cancel: {
            text: this.$t('キャンセル'),
            value: null,
            visible: true,
            className: 'btn-light',
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            value: true,
            visible: true,
            className: 'btn-light',
            closeModal: true,
          },
        },
        dangerMode: true,
      })
      if (confirm) {
        window.location.href = this.$appConfig.ScreenUrl.settingMenu
      }
    },
    async registData() {
      const method = this.isPost ? 'post' : 'put'
      const params = {
        preference: {
          visibles: this.visibles,
          hiddens: this.hiddens,
          materialVisibles: this.materialVisibles,
          materialHiddens: this.materialHiddens,
        },
      }
      if (this.isPost) {
        params.type = this.type
      } else {
        params.id = this.id
      }
      try {

        await this.$axios({
          method: method,
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
          url: `${this.$appConfig.CommonApiUrl}/company/preference`,
          data: params,
        })

        this.isPost = false

        this.$toasted.success(this.$t('登録が完了しました。'))
        this.loadSettingData()
      } catch (err) {
        console.log(err)
        this.$toasted.show(this.$t('データの登録に失敗しました。'))
      }
    },

  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
}
</script>

<style lang="scss" scoped>
  .projectbox{
    margin-top: 20px;
    display: flex;

    .hiddenBox,.visibleBox{
      border:1px solid #ccc;
      padding: 10px;
      width:13%;
      margin-right: 15px;
      h2{
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        border-bottom: 1px solid #ccc;
        padding-bottom: 5px;
        margin-bottom: 5px;
      }
      .list-group{
        height: 460px;
        overflow-y: scroll;
      }
      .list-group-item{
        border: 1px solid #ddd;
        padding: 10px;
        border-radius: 4px;
        margin-bottom: 5px;
        font-size: 13px;
        cursor:move;
        &:hover{
          border-color:#ccc;
          background-color: #efefef;
        }
        &.sortable-chosen{
          opacity:0.4;
          border:1px dotted #000;
        }
        &.isRequire{
          background-color: rgb(255, 209, 209);
        }
      }
    }
    .list-group{
      min-height: 200px;
    }
    .preview{
      border:1px solid #ccc;
      padding: 10px;
      width:72%;
      .previewBox{
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        align-items: stretch;

      }
      .box{
        width: 33.333333%;
        border: 1px solid #ddd;
        display: flex;
        align-items: stretch;
        &.full{
          width: 100%;

        }
        &.heaf{
          width: 50%;

        }
        span{
          display: inline-block;
          padding: 5px;
          width: 150px;
          font-size: 12px;
          background-color: #eee;
          border-right: 1px solid #ddd;
        }
      }
      .remark{
        border: 1px solid #ddd;
        span{
          display: inline-block;
          padding: 5px;
          width: 120px;
          background-color: #eee;
          border-right: 1px solid #ddd;
        }
      }
      h2{
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        border-bottom: 1px solid #ccc;
        padding-bottom: 5px;
        margin-bottom: 5px;
      }
    }
  }

  .mast{
    padding-top: 10px;
    border-bottom: 1px solid #ccc;
    .form-check{
      display: inline-block;
      margin-left: 10px;
      .form-check-input{
        margin-top: 3px;
      }
    }
  }

  h3{
    margin-top: 40px;
  }
  .control_btns{
    display: flex;
    margin-top: 20px;
    border-top: 1px solid #ccc;
    padding-top: 20px;
    padding-bottom: 20px;
    .btns1,.btns2{
      width: 50%;
    }
    .btns2{
      text-align: right;
    }
    .btn{
      display: inline-block;
    }
  }
</style>
